import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    emailTokenVerificationResponse: null
  },
  getters: {
    EMAIL_VERIFICATION_RESPONSE: state => state.emailTokenVerificationResponse
  },
  mutations: {
    SET_EMAIL_VERIFICATION_RESPONSE: (state, payload) => {
      state.emailTokenVerificationResponse = payload
    }
  },
  actions: {
    VERIFY_EMAIL: async (context, payload) => {
      try {
        const response = await Axios.post('/user/verify-token', payload)
        context.commit('SET_EMAIL_VERIFICATION_RESPONSE', response.data)
      } catch (error) {
        context.commit('SET_EMAIL_VERIFICATION_RESPONSE', error.response.data)
      }
    }
  }
}
